<template>
    <div>
        <modal id="importSegments" ref="importSegments">
            <template slot="title">{{ t("segments-create_modal-title") }}</template>
            <template slot="body">
                <div class="field">
                    <label>{{ t("segments-create_modal-label") }}</label>
                    <input type="text" v-model="segmentName" class="form-control" @input="validateForm" />
                    <p v-if="error" class="error-message">{{ error }}</p>
                </div>
                <template v-if="step === 'loading'">
                    <div style="font-size: 14px; margin: 10px 0;">
                        <span class="far loader fa-spinner fa-spin"></span>
                        {{ t("segments-create_modal-loading") }}
                    </div>
                </template>
            </template>
            <template slot="footer">
                <button class="btn btn-success" @click="step = 'upload', $refs.importSegments.close(), error = ''">
                    {{ t("segments-create_modal-cancel") }}
                </button>
                <button class="btn btn-success" :disabled="!isValid || step === 'loading' || error !== ''" @click="createSegment">
                    {{ t("segments-create_modal-create") }}
                </button>
            </template>
        </modal>
        <button class="create-segments-btn" @click="$refs.importSegments.open()" :aria-label="t('segments-create_modal-trigger')" style="border:none; padding:0; margin: 0; background: none;">
            <slot>
                <span>
                    <Icon icon-class="ui-plus" size="6" :tooltip="t('segments-create_modal-trigger')" />
                </span>
            </slot>
        </button>
    </div>
</template>

<script>
import keviApi from "../../keviApi.js";
import Icon from "../icon/icon";

export default {
    name: "segments",
    components: { Icon },
    props: {
        url: {
            type: String,
            required: true
        },
        filters: {
            required: true
        }
    },
    data() {
        return {
            segmentName: "",
            error: "",
            step: "upload",
            isValid: false
        };
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        validateForm() {
            this.isValid = this.segmentName.trim().length > 0;
        },
        async createSegment() {
            if (!this.isValid) return;

            this.step = "loading";
            this.error = "";
            try {
                const response = await this.$http(keviApi.getOptions(this.url, "POST", {
                    creatingSegment: true,
                    segmentName: this.segmentName,
                    filters: this.filters
                }));
                if (response.status === 201) {
                    this.$refs.importSegments.close();
                    await this.$store.dispatch(
                        "notification/success",
                        this.t("segments-create_modal-success"),
                    );
                }
            } catch (error) {
                if (error.status === 400) {
                    this.error = error.body.message;
                } else {
                    this.error = this.t("segments-create_modal-internal_error");
                }
            } finally {
                this.step = "upload";
            }
        }
    }
};
</script>

<style scoped lang="scss">
.field {
    margin-top: 20px;

    label {
        font-size: 14px;
        font-weight: 500;
    }
}

.error-message {
    margin-top: 2px;
    margin-left: 2px;
    color: red;
}

.btn-icon {
    display: flex;
    align-items: center;
    padding: 7px 1px;
}

::v-deep {
    .modal-dialog {
        max-width: 500px;
    }
}
</style>
